import type { TieredPriceConfig } from "@project/common";
import { getMeterValuePartial, UnitLabels } from "@project/common";
import type { IntlShape } from "react-intl";

export function displaySum(intl: IntlShape, price: TieredPriceConfig, sum: number) {
  const value = getMeterValuePartial(price, sum);

  if (value < 1 && price.unitLabel === UnitLabels.K_REQUESTS) {
    return intl.formatNumber(sum, { maximumFractionDigits: 0 });
  }
  if (value < 1 && price.unitLabel === UnitLabels.GB) {
    return `${intl.formatNumber(value * 1024, { maximumFractionDigits: 0 })}MB`;
  }

  return intl.formatNumber(value, { maximumFractionDigits: 2 });
}

export function displayFreeAllowance(intl: IntlShape, price: TieredPriceConfig, unitLabel?: string) {
  if (price.unitLabel === UnitLabels.K_REQUESTS || price.unitLabel === UnitLabels.TOKEN) {
    return intl.formatNumber(price.freeTierAllowance * price.unitSize, {
      maximumFractionDigits: 0,
      notation: "compact",
    });
  }
  if (price.unitLabel === UnitLabels.GB) {
    return `${intl.formatNumber(price.freeTierAllowance, {
      maximumFractionDigits: 0,
      notation: "compact",
    })}${unitLabel}`;
  }

  if (price.unitLabel === UnitLabels.MINUTE) {
    return `${intl.formatNumber(price.freeTierAllowance, {
      maximumFractionDigits: 0,
      notation: "compact",
    })} ${unitLabel}`;
  }
  return price.freeTierAllowance;
}

export function formatUSD(intl: IntlShape, value: number, limitFractionalDigits = true): string {
  return intl.formatNumber(value, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: limitFractionalDigits ? 2 : undefined,
  });
}

export function displayUnitCost(intl: IntlShape, productPrice: TieredPriceConfig) {
  const priceInCents = Number(productPrice.price);

  if (productPrice.unitLabel === UnitLabels.TOKEN) {
    return formatUSD(intl, (priceInCents / 100) * 1_000_000);
  }

  return formatUSD(intl, priceInCents / 100);
}
